/// <reference path="./typings/types.d.ts" />

import * as React from 'react';

/**
 * クラス
 */
export class Input extends React.Component<InputProps, {}> {

	private textInput : HTMLInputElement

	constructor(props : InputProps) {
		super(props);
	}

	componentDidMount() {
		if (this.props.autoFocus) this.textInput.focus();
	}

	// フォーカス時
	onFocus(e : React.FocusEvent<HTMLInputElement>) {
		const value = this.textInput.value;
		if (value || this.props.displayFocus) {
			this.props.parent.refine(value);
		}
	}

	// フォーカスが外れた時
	onBlur(e : React.FocusEvent<HTMLInputElement>) {
		this.props.parent.dataListClose();
		this.props.parent.changeSelectItem(-1);
		this.props.parent.clearSelectValue();
	}

	// キーを押した時
	onKeyDown(e : React.KeyboardEvent<HTMLInputElement>) {
		const itemNumber = this.props.parent.getSelectedItem();
		const itemCount  = this.props.parent.getItemCount();
		const inputValue = this.props.parent.getInputValueState();

		let selectItemNumber = itemNumber;

		// 選択項目の移動（選択項目の番号を増減）
		if (itemCount > 0) {
			if (e.key === 'ArrowDown') {
				selectItemNumber++;
				if (selectItemNumber >= itemCount) {
					selectItemNumber = -1;
					this.props.parent.setSelectValue(inputValue);
					this.props.parent.setValue(inputValue);
				}
				this.props.parent.changeSelectItem(selectItemNumber);
			} else if (e.key === 'ArrowUp') {
				if (selectItemNumber === -1) {
					selectItemNumber = itemCount - 1;
				} else {
					selectItemNumber--;
				}
				if (selectItemNumber <= -1) {
					selectItemNumber = -1;
					this.props.parent.setSelectValue(inputValue);
					this.props.parent.setValue(inputValue);
				}
				this.props.parent.changeSelectItem(selectItemNumber);
			}
		} else {
			this.props.parent.changeSelectItem(-1);
		}

		if (this.props.onKeyDown) this.props.onKeyDown(e, this.textInput.value);
	}

	// キーが離れたとき
	onKeyUp(e : React.KeyboardEvent<HTMLInputElement>) {
		const itemNumber  = this.props.parent.getSelectedItem();
		const selectValue = this.props.parent.getSelectValue();
		const itemCount   = this.props.parent.getItemCount();
		const inputValue  = this.textInput.value;

		// 項目が選択されている時にEnterキーで入力欄に代入
		if (e.key === 'Enter' && itemNumber > -1) {
			e.preventDefault();
			this.props.parent.setValue(selectValue);
			this.props.parent.resetState();
		}

		// サジェストが非表示の状態で上下矢印キーを押したらサジェストを表示
		if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && itemNumber === -1) {
			if (inputValue) this.props.parent.refine(inputValue);
		}

		// Escキーを押したら候補リストを閉じる
		if (e.key === 'Escape' && itemCount > 0) {
			this.props.parent.resetState();
		}

		// 選択された候補項目をプレビュー
		if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && itemNumber > -1) {
			if (this.props.parent.inputPreview) {
				this.props.parent.setValue(selectValue);
			}
		}

		if (this.props.onKeyUp) this.props.onKeyUp(e, inputValue);
	}

	// キーを押して離した時
	onKeyPress(e : React.KeyboardEvent<HTMLInputElement>) {
		const itemNumber = this.props.parent.getSelectedItem();

		if (e.key !== 'Enter' || e.key === 'Enter' && itemNumber === -1) {
			if (e.key === 'Enter' && itemNumber === -1) {
				this.props.parent.dataListClose();
				this.props.parent.changeSelectItem(-1);
				this.props.parent.clearSelectValue();
			}

			if (this.props.onKeyPress) this.props.onKeyPress(e, this.textInput.value);
		}
	}

	// 内容が変化した時
	onChange(e : React.FormEvent<HTMLInputElement>) {
		const value = this.textInput.value;

		if (value === '') {
			this.props.parent.dataListClose();
		}

		this.props.parent.setInputValue(value);
		this.props.parent.refine(value);

		if (this.props.onChange) this.props.onChange(value);
	}

	// 入力要素の取得（外部操作用）
	getInput = () => {
		return this.textInput;
	}

	// レンダリング
	render() {
		return (
			<p className='input-field'>
				<input
					ref               = { (input:any) => this.textInput = input }
					placeholder       = { this.props.placeholder }
					name              = { this.props.name }
					id                = { this.props.id }
					aria-autocomplete = { 'list' }
					aria-owns         = { this.props.dataListId }
					onFocus           = { (e:any) => this.onFocus(e) }
					onBlur            = { (e:any) => this.onBlur(e) }
					onKeyDown         = { (e:any) => this.onKeyDown(e) }
					onKeyUp           = { (e:any) => this.onKeyUp(e) }
					onKeyPress        = { (e:any) => this.onKeyPress(e) }
					onChange          = { (e:any) => this.onChange(e) }
					/>
			</p>
		);
	}
}



// WEBPACK FOOTER //
// ./src/auto-suggest/src/input.tsx